import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@/components/common/ResponsiveTable';
import DonationExtSourcesNames from '@/constants/DonationExtSourcesNames';
import { DONATION_RECURRING_CADENCES } from '@/lib/configs/contributions';
import translate from '@/lib/intl/translate';
import { DonorType } from '@/propTypes';
import { formatCurrency } from '@/utils/currency';
import { formatDate } from '@/utils/dates';

function ConstituentRecurringDonationsTable({ data }) {
  return (
    <TableContainer className="mb-4">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell className="text-right">
              {translate('AMOUNT_LABEL')}
            </TableCell>
            <TableCell>{translate('RECURRING_DONATION_CADENCE')}</TableCell>
            <TableCell>{translate('RECURRING_DONATION_START_DATE')}</TableCell>
            <TableCell>{translate('RECURRING_DONATION_SOURCE')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((donation) => {
            if (Object.keys(donation).length === 0) {
              return null;
            }

            const {
              cadence,
              extSource,
              planId,
              recurringAmount,
              startDate,
              status,
            } = donation;

            return (
              <TableRow key={planId}>
                <TableCell
                  className="col-start-2 text-left font-normal md:text-right"
                  label={translate('AMOUNT_LABEL')}
                >
                  {formatCurrency(recurringAmount, true)}
                </TableCell>
                <TableCell
                  className="col-start-2 text-left font-normal"
                  label={translate('RECURRING_DONATION_CADENCE')}
                >
                  <div className="flex items-center capitalize">
                    {
                      DONATION_RECURRING_CADENCES.find(
                        ({ value }) => value === cadence,
                      ).text
                    }
                    {status && ` (${status})`}
                  </div>
                </TableCell>
                <TableCell
                  className="col-start-2 font-normal"
                  label={translate('RECURRING_DONATION_START_DATE')}
                >
                  <div className="flex items-center">
                    {formatDate(startDate)}
                  </div>
                </TableCell>
                <TableCell
                  className="col-start-2 font-normal capitalize"
                  label={translate('RECURRING_DONATION_SOURCE')}
                >
                  {DonationExtSourcesNames[extSource]}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ConstituentRecurringDonationsTable.propTypes = {
  data: DonorType,
};

ConstituentRecurringDonationsTable.defaultProps = {
  data: {},
};

export default ConstituentRecurringDonationsTable;
